<om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
<nz-input-number [formControl]="control" [nzPlaceHolder]="placeholder" [nzMin]="min" [nzMax]="max" [nzStep]="step" class="w-full"></nz-input-number>
<div class="om-error-placeholder">
  <om-error [control]="control"></om-error>
</div>
